import React, { useState, useCallback, useRef, useEffect } from 'react';
import { getTime } from 'date-fns';

import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { useHistory } from 'react-router-dom';
import Select from '../../components/Select';
import SearchField, { SearchFieldHandles } from '../../components/SearchField';
import InputLogged from '../../components/InputLogged';
import OrderTable, { Data } from './OrderTable';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';

import ActivityIndicator from '../../components/ActivityIndicator';

import BRLMoneyFormat from '../../utils/BRLMoneyFormat';

import {
  Container,
  AdvancedSearch,
  InputWrapper,
  PageTitle,
  ButtonsContainer,
  TotalContainer,
} from './styles';
import stylesMaterial from './stylesMaterial';
import OrdersService from '../../services/OrdersService';
import {
  getCompanyMonthRange,
  getValidTimeZone,
} from '../../utils/companyDate';

export interface OptionType {
  id: number;
  value: any;
  label: string;
  time_zone?: string;
}

const statusOptions: OptionType[] = [
  { id: 0, value: '', label: 'Todos' },
  { id: 1, value: 0, label: 'Aguardo' },
  { id: 2, value: 1, label: 'Aceito' },
  { id: 3, value: 2, label: 'Negado' },
  { id: 4, value: 3, label: 'Preparação' },
  { id: 5, value: 4, label: 'Pronto' },
  { id: 6, value: 5, label: 'Rota Entrega' },
  { id: 7, value: 6, label: 'Entregue' },
  { id: 8, value: 7, label: 'Faturado' },
  { id: 9, value: 8, label: 'Separado' },
  { id: 10, value: 9, label: 'Cancelado' },
  { id: 11, value: 10, label: 'Cancelado Cliente' },
  { id: 12, value: 11, label: 'Pronto retirada' },
  { id: 13, value: 12, label: 'Em separação' },
];

const initialSelectOption: OptionType = {
  id: 0,
  label: 'Todas',
  value: '',
};

const pdvPlatformOption: OptionType = {
  id: 4,
  value: 'pdv',
  label: 'PDV',
};

const getFirstDayOfMonth = (timeZone: string): string => {
  return getCompanyMonthRange(new Date(), timeZone)[0];
};

const getLastDayOfMonth = (timeZone: string): string => {
  return getCompanyMonthRange(new Date(), timeZone)[1];
};

const Historico: React.FC = () => {
  const classes = stylesMaterial();

  const { addToast } = useToast();
  const { user, caixa, rotinas, findRotinas } = useAuth();
  const history = useHistory();

  const formRef = useRef<FormHandles>(null);
  const searchFieldRef = useRef<SearchFieldHandles>(null);

  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<Data[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<OptionType>({
    id: user.empresa_id,
    value: user.empresa_id,
    label: user.empresa_nome_fantasia,
  });
  const companyTimeZone = getValidTimeZone(
    selectedTenant.time_zone || user?.empresa?.time_zone,
  );
  const [selectedPlataform, setSelectedPlataform] = useState<OptionType>({
    id: 1,
    value: 'all',
    label: 'Todas',
  });
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    OptionType
  >(initialSelectOption);
  const [selectedStatus, setSelectedStatus] = useState<OptionType>(
    statusOptions[0],
  );
  const [tenants, setTenants] = useState<OptionType[]>([]);
  const [paymentMethods, setPaymentMethods] = useState<OptionType[]>([
    initialSelectOption,
  ]);
  const [isPlatformDisabled, setIsPlatformDisabled] = useState(false);
  const [totalValue, setTotalValue] = useState(0);
  const [pdvFiltersLoading, setPdvFiltersLoading] = useState(false);
  const [cashiers, setCashiers] = useState<OptionType[]>([]);
  const [terminals, setTerminals] = useState<OptionType[]>([]);
  const [selectedCashier, setSelectedCashier] = useState<OptionType | null>(
    null,
  );
  const [selectedTerminal, setSelectedTerminal] = useState<OptionType | null>(
    null,
  );

  useEffect(() => {
    async function loadOrders(): Promise<void> {
      setLoading(true);

      try {
        const response = await api.get('/pedido/historico', {
          params: {
            tenant_id: user.empresa_id,
            platforms: 'all',
            from: `${getFirstDayOfMonth(getValidTimeZone(user.empresa?.time_zone))}T00:00:00`,
            to: `${getLastDayOfMonth(getValidTimeZone(user.empresa?.time_zone))}T23:59:59`,
          },
        });

        const mappedOrders = response.data.map((order: any) => ({
          type: order.type,
          pedido: order.id,
          data: getTime(new Date(order.date)),
          cliente: order.customer.split(' ')[0],
          fone: order.fone,
          pagamento: order.payment_method,
          valor: Number(order.total).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
          }),
          taxaEntrega: Number(order.delivery_fee).toLocaleString(
            'pt-BR',
            {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            },
          ),
          valordesconto: Number(order.discount).toLocaleString(
            'pt-BR',
            {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
},
          ),
          valortotal: Number(
            Number(order.total) +
              Number(order.delivery_fee) -
              Number(order.discount),
          ).toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
}),
          estagio: order.status,
        }));

        setOrders(mappedOrders);

        const total = response.data.reduce((acc: number, order: any) => {
          return (
            acc +
            Number(order.total) +
            Number(order.delivery_fee) -
            Number(order.discount)
          );
        }, 0);
        setTotalValue(total);

        setLoading(false);
      } catch (err) {
        addToast({
          title: 'Opss...',
          type: 'error',
          description:
            (err as any).response?.data.message ||
            'Ocorreu um erro ao tentar obter os pedidos.',
        });

        setLoading(false);
      }
    }

    async function loadTenants(): Promise<void> {
      try {
        const response = await api.get('/empresa');

        const loadedTenants: OptionType[] = response.data.map(
          (tenant: any) => ({
            id: tenant.id,
            label: tenant.nome_fantasia,
            value: tenant.id,
            time_zone: tenant.time_zone,
          }),
        );

        setTenants((oldState) => oldState.concat(loadedTenants));
        setSelectedTenant(loadedTenants[0]);
        formRef.current?.setFieldValue(
          'from',
          getFirstDayOfMonth(
            getValidTimeZone(loadedTenants[0]?.time_zone),
          ),
        );
        formRef.current?.setFieldValue(
          'to',
          getLastDayOfMonth(
            getValidTimeZone(loadedTenants[0]?.time_zone),
          ),
        );
      } catch (err) {
        addToast({
          title: 'Opss...',
          description: 'Ocorreu um erro ao obter as lojas',
          type: 'error',
        });
      }
    }

    async function loadPaymentMethods(): Promise<void> {
      try {
        const response = await api.get(
          `/formas_pagamento_empresa/${user.empresa_id}`,
        );

        const loadedPaymentMethods = response.data.map(
          (paymentMethod: any) => ({
            id: paymentMethod.id,
            label: paymentMethod.forma_pagamento.descricao,
            value: paymentMethod.id,
          }),
        );

        setPaymentMethods((oldState) => oldState.concat(loadedPaymentMethods));
      } catch (err) {
        addToast({
          title: 'Opss...',
          description: 'Ocorreu um erro ao obter as formas de pagamento',
          type: 'error',
        });
      }
    }

    loadOrders();
    loadTenants();
    loadPaymentMethods();
  }, [user.empresa_id, addToast]);

  useEffect(() => {
    let isMounted = true;

    async function loadPdvFilters(): Promise<void> {
      if (selectedPlataform.value !== 'pdv') {
        if (isMounted) {
          setCashiers([]);
          setTerminals([]);
          setSelectedCashier(null);
          setSelectedTerminal(null);
        }
        return;
      }

      if (isMounted) {
        setPdvFiltersLoading(true);
      }

      try {
        const response = await api.get(
          `/pdv/companies/${user.empresa_id}/filters`,
        );

        if (!isMounted) return;

        const loadedCashiers: OptionType[] = [
          { id: 0, value: '', label: 'Todos' },
          ...(response.data.cashiers || [])
            .sort((a: any, b: any) => {
              const dateA = new Date(a.started_at).getTime();
              const dateB = new Date(b.started_at).getTime();
              return dateB - dateA;
            })
            .map((cashier: any, index: number) => ({
              id: index + 1,
              label: cashier.name || `Caixa ${cashier.observation}`,
              value: cashier.id,
            })),
        ];

        const loadedTerminals: OptionType[] = [
          { id: 0, value: '', label: 'Todos' },
          ...(response.data.terminals || []).map(
            (terminal: any, index: number) => ({
              id: index + 1,
              label: terminal.name || `Terminal ${terminal.terminal}`,
              value: terminal.terminal,
            }),
          ),
        ];

        setCashiers(loadedCashiers);
        setTerminals(loadedTerminals);
      } catch (err) {
        if (isMounted) {
          addToast({
            title: 'Opss...',
            description: 'Ocorreu um erro ao obter os filtros do PDV',
            type: 'error',
          });
        }
      } finally {
        if (isMounted) {
          setPdvFiltersLoading(false);
        }
      }
    }

    loadPdvFilters();

    return () => {
      isMounted = false;
    };
  }, [selectedPlataform.value, user.empresa_id, addToast]);

  const clearForm = useCallback(() => {
    formRef.current?.reset();
    formRef.current?.setErrors({});
    formRef.current?.setFieldValue('from', getFirstDayOfMonth(companyTimeZone));
    formRef.current?.setFieldValue('to', getLastDayOfMonth(companyTimeZone));
    setSelectedTenant({
      id: 0,
      value: '',
      label: 'Selecione uma loja',
    });
    setSelectedPaymentMethod(initialSelectOption);
    setSelectedStatus(statusOptions[0]);
    setSelectedPlataform({
      id: 1,
      value: 'all',
      label: 'Todas',
    });
    setIsPlatformDisabled(false);
    setSelectedCashier(null);
    setSelectedTerminal(null);
  }, [companyTimeZone]);

  const handleSearchFilterChange = useCallback((filter: string) => {
    if (filter === 'caixa' || filter === 'terminal') {
      setSelectedPlataform(pdvPlatformOption);
      setIsPlatformDisabled(true);
    } else {
      setIsPlatformDisabled(false);
    }
  }, []);

  const handleCancelOrder = useCallback(
    async (pedido: number) => {
      try {
        setOrders((oldState) =>
          oldState.map((order) => {
            if (order.pedido === pedido) {
              return {
                ...order,
                estagio: 9,
              };
            }

            return order;
          }),
        );

        await OrdersService.editOrderStatus(
          user.empresa_id,
          caixa.id,
          pedido,
          9,
        );
      } catch (err) {
        const { message } = (err as any).response.data;

        addToast({
          title: 'Erro',
          description: message,
          type: 'error',
        });
      }
    },
    [user, caixa, addToast],
  );

  const handleSubmit = useCallback(
    async (data) => {
      setLoading(true);
      formRef.current?.setErrors({});

      const params = {};

      if (data.from && data.to) {
        if (data.from > data.to) {
          formRef.current?.setFieldError('from', 'Data inválida');
          formRef.current?.setFieldError('to', 'Data inválida');

          setLoading(false);

          return;
        }

        Object.assign(params, {
          from: `${data.from}T00:00:00`,
          to: `${data.to}T23:59:59`,
        });
      } else {
        if (!data.from && data.to) {
          formRef.current?.setFieldError('from', 'Informe uma data');

          setLoading(false);

          return;
        }

        if (data.from && !data.to) {
          formRef.current?.setFieldError('to', 'Informe uma data');

          setLoading(false);

          return;
        }
      }

      if (!selectedTenant.value) {
        formRef.current?.setFieldError('tenant_id', 'Informe uma data');
        setLoading(false);

        return;
      }

      try {
        const {
          status,
          tenant_id,
          platforms,
          payment_method_id,
          search,
        } = data;

        if (typeof status === 'number') {
          Object.assign(params, { status });
        }

        if (payment_method_id) {
          Object.assign(params, {
            payment_method_id: Number(payment_method_id),
          });
        }

        if (selectedCashier?.value) {
          Object.assign(params, {
            cashier_id: selectedCashier.value,
          });
        }

        if (selectedTerminal?.value) {
          Object.assign(params, {
            terminal_id: selectedTerminal.value,
          });
        }

        const response = await api.get('/pedido/historico', {
          params: {
            ...params,
            search,
            searchBy: searchFieldRef.current?.getFilter(),
            tenant_id,
            platforms,
          },
        });

        const mappedOrders = response.data.map((order: any) => ({
          type: order.type,
          pedido: order.id,
          data: getTime(new Date(order.date)),
          cliente: order.customer.split(' ')[0],
          fone: order.fone,
          pagamento: order.payment_method,
          valor: Number(order.total).toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
}),
          taxaEntrega: Number(order.delivery_fee).toLocaleString(
            'pt-BR',
            {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
},
          ),
          valortotal: Number(
            Number(order.total) + Number(order.delivery_fee),
          ).toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
}),
          estagio: order.status,
        }));

        setOrders(mappedOrders);

        const total = response.data.reduce((acc: number, order: any) => {
          return acc + Number(order.total) + Number(order.delivery_fee);
        }, 0);
        setTotalValue(total);

        setLoading(false);
      } catch (err) {
        addToast({
          title: 'Opss...',
          type: 'error',
          description:
            (err as any).response?.data.message ||
            'Ocorreu um erro ao tentar obter os pedidos.',
        });

        setLoading(false);
      }
    },
    [selectedTenant, selectedCashier, selectedTerminal, companyTimeZone, addToast],
  );

  const hasPermission = useCallback(
    (): boolean => findRotinas('historico')?.listar || false,
    [findRotinas],
  );

  useEffect(() => {
    if (rotinas && !hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      history.push('/monitor_pedidos');
    }
  }, [addToast, hasPermission, history, rotinas]);

  return (
    <Container>
      <PageTitle>
        <h1>Pedidos</h1>
        <h3>
          Veja aqui os pedidos feitos em sua loja. Nesta página você pode também
          cancelar pedidos.
        </h3>
      </PageTitle>
      <Form id="search-form" ref={formRef} onSubmit={handleSubmit}>
        <AdvancedSearch>
          <div className="group__tenant">
            <InputLabel htmlFor="tenant_id" className={classes.label}>
              Loja
            </InputLabel>
            <Select
              id="tenant_id"
              name="tenant_id"
              placeholder="Selecione a loja"
              value={selectedTenant}
              onChange={(value) => setSelectedTenant(value as OptionType)}
              options={tenants}
            />
          </div>
          <div className="group__tenant">
            <InputLabel htmlFor="platforms" className={classes.label}>
              Plataforma
            </InputLabel>
            <Select
              id="platforms"
              name="platforms"
              placeholder="Selecione uma plataforma"
              value={selectedPlataform}
              onChange={(value) => setSelectedPlataform(value as OptionType)}
              isDisabled={isPlatformDisabled}
              options={[
                {
                  id: 1,
                  value: 'all',
                  label: 'Todas',
                },
                {
                  id: 2,
                  value: 'ifood',
                  label: 'iFood',
                },
                {
                  id: 3,
                  value: 'atac',
                  label: 'Atac',
                },
                {
                  id: 4,
                  value: 'pdv',
                  label: 'PDV',
                },
              ]}
            />
          </div>
          <div className="group__tenant__search">
            <SearchField
              ref={searchFieldRef}
              name="search"
              placeholder="Pesquisa"
              containerStyle={{ height: '38px' }}
              filters={[
                { id: 0, value: 'cliente', label: 'Cliente' },
                { id: 1, value: 'pedido', label: 'Número do pedido' },
              ]}
              onFilterChange={handleSearchFilterChange}
            />
          </div>
        </AdvancedSearch>

        <AdvancedSearch>
          <div className="group">
            <div className="group__input">
              <InputWrapper>
                <InputLabel htmlFor="status" className={classes.label}>
                  Estágio
                </InputLabel>
                <Select
                  id="status"
                  name="status"
                  placeholder="Selecione"
                  value={selectedStatus}
                  onChange={(value) => setSelectedStatus(value as OptionType)}
                  options={statusOptions}
                />
              </InputWrapper>
              <InputWrapper>
                <InputLabel
                  htmlFor="payment_method_id"
                  className={classes.label}
                >
                  Forma de pagamento
                </InputLabel>
                <Select
                  id="payment_method_id"
                  name="payment_method_id"
                  placeholder="Selecione a loja"
                  value={selectedPaymentMethod}
                  onChange={(value) =>
                    setSelectedPaymentMethod(value as OptionType)
                  }
                  options={paymentMethods}
                />
              </InputWrapper>
            </div>
            <div className="group__input">
              <InputWrapper>
                <InputLabel htmlFor="from" className={classes.label}>
                  De
                </InputLabel>
                <InputLogged
                  id="from"
                  name="from"
                  containerStyle={{ height: '38px' }}
                  type="date"
                  defaultValue={getFirstDayOfMonth(companyTimeZone)}
                />
              </InputWrapper>
              <InputWrapper>
                <InputLabel htmlFor="to" className={classes.label}>
                  Até
                </InputLabel>
                <InputLogged
                  id="to"
                  name="to"
                  type="date"
                  containerStyle={{ height: '38px' }}
                  defaultValue={getLastDayOfMonth(companyTimeZone)}
                />
              </InputWrapper>
            </div>
          </div>
        </AdvancedSearch>

        {selectedPlataform.value === 'pdv' && (
          <AdvancedSearch>
            <div className="group">
              <div className="group__input">
                <InputWrapper>
                  <InputLabel htmlFor="cashier_id" className={classes.label}>
                    Caixa
                  </InputLabel>
                  <Select
                    id="cashier_id"
                    name="cashier_id"
                    placeholder="Selecione um caixa"
                    value={selectedCashier}
                    onChange={(value) =>
                      setSelectedCashier(value as OptionType)
                    }
                    options={cashiers}
                    isLoading={pdvFiltersLoading}
                    isDisabled={pdvFiltersLoading}
                  />
                </InputWrapper>
                <InputWrapper>
                  <InputLabel htmlFor="terminal_id" className={classes.label}>
                    Terminal
                  </InputLabel>
                  <Select
                    id="terminal_id"
                    name="terminal_id"
                    placeholder="Selecione um terminal"
                    value={selectedTerminal}
                    onChange={(value) =>
                      setSelectedTerminal(value as OptionType)
                    }
                    options={terminals}
                    isLoading={pdvFiltersLoading}
                    isDisabled={pdvFiltersLoading}
                  />
                </InputWrapper>
              </div>
            </div>
          </AdvancedSearch>
        )}
      </Form>
      <ButtonsContainer>
      <TotalContainer>
            <span>
              Valor total dos pedidos:{' '}
              <strong>
                {totalValue.toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
})}
              </strong>
            </span>
          </TotalContainer>
          <div style={{ display: 'flex', gap: '10px' }}>
        <Button
          type="button"
          className={classes.clearFiltersButton}
          onClick={clearForm}
          disabled={loading}
        >
          Limpar filtros
        </Button>
        <Button
          type="submit"
          form="search-form"
          className={classes.consultButton}
          disabled={loading}
        >
          Consultar
        </Button>
        </div>
      </ButtonsContainer>
      {loading ? (
        <ActivityIndicator />
      ) : (
          <OrderTable
            orders={orders}
            onCancellation={handleCancelOrder}
            timeZone={companyTimeZone}
          />
      )}
    </Container>
  );
};

export default Historico;
